import { render, staticRenderFns } from "./Terms-V1.0.0.vue?vue&type=template&id=814d3d30&scoped=true&"
import script from "./Terms-V1.0.0.vue?vue&type=script&lang=js&"
export * from "./Terms-V1.0.0.vue?vue&type=script&lang=js&"
import style0 from "./Terms-V1.0.0.vue?vue&type=style&index=0&id=814d3d30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814d3d30",
  null
  
)

export default component.exports